// @flow

import qs from 'qs'

import type { APIError } from '../types'
import type { Action } from '../types/actions/mystudents'
import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeaders
} from '../utils/api'
import { getErrorAction } from '../utils/actions'

import { showModal, hideModal } from './_modal'

export const SET_MY_STUDENTS_SEARCH_TEXT = 'SET_MY_STUDENTS_SEARCH_TEXT'
export const SET_MY_STUDENTS_SELECTED_TAB = 'SET_MY_STUDENTS_SELECTED_TAB'
export const SET_MY_STUDENTS_SORT = 'SET_MY_STUDENTS_SORT'
export const SET_MY_STUDENTS_COURSE_FILTER = 'SET_MY_STUDENTS_COURSE_FILTER'
export const SET_MY_STUDENTS_SKILLS_LEVEL_FILTER =
  'SET_MY_STUDENTS_SKILLS_LEVEL_FILTER'
export const SET_MY_STUDENTS_DATE_FILTER = 'SET_MY_STUDENTS_DATE_FILTER'
export const FETCH_LOCKED_LEVELS_REQUEST = 'FETCH_LOCKED_LEVELS_REQUEST'
export const FETCH_LOCKED_LEVELS_SUCCESS = 'FETCH_LOCKED_LEVELS_SUCCESS'
export const FETCH_LOCKED_LEVELS_FAILURE = 'FETCH_LOCKED_LEVELS_FAILURE'
export const DISPLAY_RESPONSES_MODAL = 'DISPLAY_RESPONSES_MODAL'
export const REMOVE_LOCKED_LEVEL = 'REMOVE_LOCKED_LEVEL'
export const FETCH_ENGAGEMENT_USERS_REQUEST = 'FETCH_ENGAGEMENT_USERS_REQUEST'
export const FETCH_ENGAGEMENT_USERS_SUCCESS = 'FETCH_ENGAGEMENT_USERS_SUCCESS'
export const FETCH_ENGAGEMENT_USERS_FAILURE = 'FETCH_ENGAGEMENT_USERS_FAILURE'
export const FETCH_USERS_DAILY_EFFORTS_REQUEST =
  'FETCH_USERS_DAILY_EFFORTS_REQUEST'
export const FETCH_USERS_DAILY_EFFORTS_SUCCESS =
  'FETCH_USERS_DAILY_EFFORTS_SUCCESS'
export const FETCH_USERS_DAILY_EFFORTS_FAILURE =
  'FETCH_USERS_DAILY_EFFORTS_FAILURE'
export const UPDATE_USER_DAILY_EFFORT_REQUEST =
  'UPDATE_USER_DAILY_EFFORT_REQUEST'
export const UPDATE_USER_DAILY_EFFORT_SUCCESS =
  'UPDATE_USER_DAILY_EFFORT_SUCCESS'
export const DELETE_USER_DAILY_EFFORT_REQUEST =
  'DELETE_USER_DAILY_EFFORT_REQUEST'
export const DELETE_USER_DAILY_EFFORT_SUCCESS =
  'DELETE_USER_DAILY_EFFORT_SUCCESS'
export const ADD_EMPTY_ROW_TO_USER_DAILY_EFFORTS =
  'ADD_EMPTY_ROW_TO_USER_DAILY_EFFORTS'
export const EXPAND_LEVEL_COLUMN = 'EXPAND_LEVEL_COLUMN'
export const COLLAPSE_LEVEL_COLUMN = 'COLLAPSE_LEVEL_COLUMN'
export const SET_DISPLAY_LEVEL_VIEW = 'SET_DISPLAY_LEVEL_VIEW'
export const SET_MY_STUDENTS_TRENDS_VIEW = 'SET_MY_STUDENTS_TRENDS_VIEW'

export const MY_STUDENTS_FETCH_OVERALL_QUESTS_PROGRESS =
  'MY_STUDENTS_FETCH_OVERALL_QUESTS_PROGRESS'
export const MY_STUDENTS_CREATE_TARGET_DATE_SUCCESS =
  'MY_STUDENTS_CREATE_TARGET_DATE_SUCCESS'

export const MY_STUDENTS_UPDATE_TARGET_DATE_SUCCESS =
  'MY_STUDENTS_UPDATE_TARGET_DATE_SUCCESS'
export const MY_STUDENTS_UPDATE_TARGET_DATE_ERROR =
  'MY_STUDENTS_UPDATE_TARGET_DATE_ERROR'

export const MY_STUDENTS_UPDATE_TARGET_DATE_ALL =
  'MY_STUDENTS_UPDATE_TARGET_DATE_ALL'
export const MY_STUDENTS_UPDATE_TARGET_DATE_ALL_SUCCESS =
  'MY_STUDENTS_UPDATE_TARGET_DATE_ALL_SUCCESS'

export const MY_STUDENTS_DELETE_TARGET_DATE_SUCCESS =
  'MY_STUDENTS_DELETE_TARGET_DATE_SUCCESS'
export const MY_STUDENTS_DELETE_TARGET_DATE_ERROR =
  'MY_STUDENTS_DELETE_TARGET_DATE_ERROR'

export function displayResponsesModalAction(
  display: boolean,
  user: ?Object,
  selfAssessment: boolean
): Action {
  return {
    type: DISPLAY_RESPONSES_MODAL,
    display: display,
    user: user,
    selfAssessment: selfAssessment
  }
}

export function setMyStudentsSearchText(searchText: string): Action {
  return {
    type: SET_MY_STUDENTS_SEARCH_TEXT,
    searchText: searchText
  }
}

export function setMyStudentsSelectedTab(tab: string): Action {
  return {
    type: SET_MY_STUDENTS_SELECTED_TAB,
    tab: tab
  }
}

export function setMyStudentsSort(field: string, direction: string): Action {
  return {
    type: SET_MY_STUDENTS_SORT,
    field: field,
    direction: direction
  }
}

export function setMyStudentsDateFilter(date: Date): Action {
  return {
    type: SET_MY_STUDENTS_DATE_FILTER,
    dateFilter: date
  }
}

export function setCourseFilter(courseSectionId: number): Action {
  return {
    type: SET_MY_STUDENTS_COURSE_FILTER,
    courseSectionId: courseSectionId
  }
}

export function setSkillsLevelFilter(levelId: number): Action {
  return {
    type: SET_MY_STUDENTS_SKILLS_LEVEL_FILTER,
    levelId: levelId
  }
}

export function fetchLockedLevelsRequest(): Action {
  return {
    type: FETCH_LOCKED_LEVELS_REQUEST
  }
}

export function fetchLockedLevelsSuccess(response: Array<Object>): Action {
  return {
    type: FETCH_LOCKED_LEVELS_SUCCESS,
    lockedLevels: response
  }
}

export function fetchLockedLevelsFailure(error: APIError): Action {
  return getErrorAction(FETCH_LOCKED_LEVELS_FAILURE, error)
}

export function fetchEngagementUsersRequest(): Action {
  return {
    type: FETCH_ENGAGEMENT_USERS_REQUEST
  }
}

export function fetchEngagementUsersSuccess(
  users: Array<Object>,
  efforts: Array<Object>
): Action {
  return {
    type: FETCH_ENGAGEMENT_USERS_SUCCESS,
    engagementUsers: users,
    engagementEfforts: efforts
  }
}

export function fetchEngagementUsersFailure(error: APIError): Action {
  return getErrorAction(FETCH_ENGAGEMENT_USERS_FAILURE, error)
}

export function fetchUsersDailyEffortsRequest(): Action {
  return {
    type: FETCH_USERS_DAILY_EFFORTS_REQUEST
  }
}

export function fetchUsersDailyEffortsSuccess(efforts: Array<Object>): Action {
  return {
    type: FETCH_USERS_DAILY_EFFORTS_SUCCESS,
    engagementEfforts: efforts
  }
}

export function fetchUsersDailyEffortsFailure(error: APIError): Action {
  return getErrorAction(FETCH_USERS_DAILY_EFFORTS_FAILURE, error)
}

export function updateUserDailyEffortRequest(): Action {
  return {
    type: UPDATE_USER_DAILY_EFFORT_REQUEST
  }
}

export function updateUserDailyEffortSuccess(
  response: Object,
  updateUI: boolean
): Action {
  return {
    type: UPDATE_USER_DAILY_EFFORT_SUCCESS,
    userDailyEfforts: response,
    updateUI: updateUI
  }
}

export function deleteUserDailyEffortRequest(): Action {
  return {
    type: DELETE_USER_DAILY_EFFORT_REQUEST
  }
}

export function deleteUserDailyEffortSuccess(
  studentId: number,
  effortId: number
): Action {
  return {
    type: DELETE_USER_DAILY_EFFORT_SUCCESS,
    studentId: studentId,
    effortId: effortId
  }
}

export function removeLockedLevel(levelId: number): Action {
  return {
    type: REMOVE_LOCKED_LEVEL,
    levelId: levelId
  }
}

export function addEmptyRowToUserDailyEfforts(
  studentId: number,
  record: Object
) {
  return {
    type: ADD_EMPTY_ROW_TO_USER_DAILY_EFFORTS,
    studentId: studentId,
    record: record
  }
}

export function expandLevelColumn(id) {
  return {
    type: EXPAND_LEVEL_COLUMN,
    payload: {
      id
    }
  }
}

export function collapseLevelColumn(id) {
  return {
    type: COLLAPSE_LEVEL_COLUMN,
    payload: {
      id
    }
  }
}

export function actionSetDisplayLevelView(displayLevelView): Action {
  return {
    type: SET_DISPLAY_LEVEL_VIEW,
    payload: {
      displayLevelView: displayLevelView
    }
  }
}

export function setMyStudentsTrendsView(trendsView): Action {
  return {
    type: SET_MY_STUDENTS_TRENDS_VIEW,
    payload: {
      trendsView
    }
  }
}

export function actionMyStudentsFetchOverallQuestsProgress(payload) {
  return {
    type: MY_STUDENTS_FETCH_OVERALL_QUESTS_PROGRESS,
    payload
  }
}

export function actionMyStudentsUpdateTargetDateSuccess(
  id,
  questId,
  levelId,
  studentId,
  courseSectionId,
  targetOn
) {
  return {
    type: MY_STUDENTS_UPDATE_TARGET_DATE_SUCCESS,
    payload: {
      id,
      questId,
      levelId,
      studentId,
      courseSectionId,
      targetOn
    }
  }
}

export function actionMyStudentsUpdateTargetDateError(
  id,
  questId,
  levelId,
  studentId,
  targetOn
) {
  return {
    type: MY_STUDENTS_UPDATE_TARGET_DATE_ERROR,
    payload: {
      id,
      questId,
      levelId,
      studentId,
      targetOn
    }
  }
}

export function actionMyStudentsUpdateTargetDateAll(
  id,
  questId,
  levelId,
  studentId,
  targetOn
) {
  return {
    type: MY_STUDENTS_UPDATE_TARGET_DATE_ALL,
    payload: {
      id,
      questId,
      levelId,
      studentId,
      targetOn
    }
  }
}

export function actionMyStudentsUpdateTargetDateAllSuccess(payload) {
  return {
    type: MY_STUDENTS_UPDATE_TARGET_DATE_ALL_SUCCESS,
    payload
  }
}

export function actionMyStudentsUpdateTargetDate(
  id,
  questId,
  levelId,
  studentId,
  courseSectionId,
  targetOn,
  applytoAll = false
): Function {
  return async (dispatch, getState) => {
    const state = getState()

    let url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/users/${studentId}/quest_target_dates/${id}`

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PUT',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            apply_to_all_section_students: applytoAll,
            user_quest_target_date: {
              quest_id: questId,
              course_section_id: courseSectionId,
              level_id: levelId,
              target_on: targetOn
            }
          })
        })
      )

      const targetDate = await response.json()

      dispatch(
        actionMyStudentsUpdateTargetDateSuccess(
          targetDate.id,
          questId,
          levelId,
          studentId,
          courseSectionId,
          targetDate.target_on
        )
      )
      dispatch(hideModal())
      if (applytoAll) {
        dispatch(
          actionMyStudentsUpdateTargetDateAll(
            targetDate.id,
            questId,
            levelId,
            studentId,
            targetDate.target_on
          )
        )
      }
    } catch (e) {
      dispatch(showModal('TARGET_DATE_SAVING_ERROR', {}))
    }
  }
}

export function actionMyStudentsDeleteTargetDateSuccess(id, studentId) {
  return {
    type: MY_STUDENTS_DELETE_TARGET_DATE_SUCCESS,
    payload: {
      id,
      studentId
    }
  }
}

export function actionMyStudentsDeleteTargetDateError(id, studentId) {
  return {
    type: MY_STUDENTS_DELETE_TARGET_DATE_ERROR,
    payload: {
      id,
      studentId
    }
  }
}

export function actionMyStudentsDeleteTargetDate(id, studentId): Function {
  return async (dispatch, getState) => {
    const state = getState()
    let url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/users/${studentId}/quest_target_dates/${id}`

    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'DELETE',
          headers: getApiHeaders(state)
        })
      )

      dispatch(actionMyStudentsDeleteTargetDateSuccess(id, studentId))
    } catch (e) {
      dispatch(showModal('TARGET_DATE_SAVING_ERROR', {}))
    }
  }
}

export function actionMyStudentsCreateTargetDateSuccess(
  id,
  questId,
  levelId,
  studentId,
  courseSectionId,
  targetOn
) {
  return {
    type: MY_STUDENTS_CREATE_TARGET_DATE_SUCCESS,
    payload: {
      id,
      questId,
      levelId,
      courseSectionId,
      studentId,
      targetOn
    }
  }
}

export function actionMyStudentsCreateTargetDateError(id, studentId) {
  return {
    type: MY_STUDENTS_DELETE_TARGET_DATE_ERROR,
    payload: {
      id,
      studentId
    }
  }
}

export function actionMyStudentsCreateTargetDate(
  questId,
  levelId,
  studentId,
  courseSectionId,
  targetOn,
  applytoAll = false
): Function {
  return async (dispatch, getState) => {
    const state = getState()

    let url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/users/${studentId}/quest_target_dates`

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            apply_to_all_section_students: applytoAll,
            user_quest_target_date: {
              quest_id: questId,
              course_section_id: courseSectionId,
              level_id: levelId,
              target_on: targetOn
            }
          })
        })
      )

      const targetDate = await response.json()
      dispatch(
        actionMyStudentsCreateTargetDateSuccess(
          targetDate.id,
          questId,
          levelId,
          studentId,
          courseSectionId,
          targetDate.target_on
        )
      )
      dispatch(hideModal())
      if (applytoAll) {
        dispatch(
          actionMyStudentsUpdateTargetDateAll(
            targetDate.id,
            questId,
            levelId,
            studentId,
            targetDate.target_on
          )
        )
      }
    } catch (e) {
      dispatch(showModal('TARGET_DATE_SAVING_ERROR', {}))
    }
  }
}

export function fetchLockedLevels(courseSectionId: number): Function {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(fetchLockedLevelsRequest())

    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/mentor/course_sections/${courseSectionId}/locked_levels/`

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )

      const data = await response.json()

      dispatch(fetchLockedLevelsSuccess(data))
    } catch (error) {
      dispatch(fetchLockedLevelsFailure(error))
    }
  }
}

export function fetchEngagementUsers(courseSectionId: number): Function {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(fetchEngagementUsersRequest())

    try {
      // first, get the students for this course section
      const params = qs.stringify({
        q: {
          user_organizations_roles_array_contains: 'qa_student'
        }
      })

      const usersResponse = checkHttpStatus(
        await fetch(
          `${getApiBaseUrlWithOrg(
            state.organization.orgId
          )}/course_sections/${courseSectionId}/users?${params}`,
          {
            method: 'GET',
            headers: getApiHeaders(state)
          }
        )
      )

      const users = await usersResponse.json()

      // second, get the efforts for the students
      const effortParams = qs.stringify({
        q: {
          effort_on_eq: state.mystudents.dateFilter
        }
      })

      const effortsResponse = checkHttpStatus(
        await fetch(
          `${getApiBaseUrlWithOrg(
            state.organization.orgId
          )}/mentor/course_sections/${courseSectionId}/user_daily_efforts?${effortParams}`,
          {
            method: 'GET',
            headers: getApiHeaders(state)
          }
        )
      )

      const efforts = await effortsResponse.json()

      dispatch(fetchEngagementUsersSuccess(users, efforts))
    } catch (error) {
      dispatch(fetchEngagementUsersFailure(error))
    }
  }
}

export function fetchUsersDailyEfforts(date: string): Function {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(fetchUsersDailyEffortsRequest())

    try {
      // second, get the efforts for the students
      const effortParams = qs.stringify({
        q: {
          effort_on_eq: date
        }
      })

      const effortsResponse = checkHttpStatus(
        await fetch(
          `${getApiBaseUrlWithOrg(
            state.organization.orgId
          )}/mentor/course_sections/${
            state.mystudents.courseSectionId
          }/user_daily_efforts?${effortParams}`,
          {
            method: 'GET',
            headers: getApiHeaders(state)
          }
        )
      )

      const efforts = await effortsResponse.json()

      dispatch(fetchUsersDailyEffortsSuccess(efforts))
    } catch (error) {
      dispatch(fetchUsersDailyEffortsFailure(error))
    }
  }
}

export function submitUserDailyEffort(
  body: Object,
  effortId: ?number,
  updateUI: ?boolean = true
): Function {
  return async (dispatch, getState) => {
    const state = getState()

    dispatch(updateUserDailyEffortRequest())

    let url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/mentor/course_sections/${
      state.mystudents.courseSectionId
    }/user_daily_efforts`

    if (effortId) {
      url += '/' + effortId
    }

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: effortId ? 'PATCH' : 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify(body)
        })
      )

      const data = await response.json()

      // no matter what was passed for updateUI, if we just created a record - do a UI update
      dispatch(updateUserDailyEffortSuccess(data, !effortId ? true : updateUI))
    } catch (error) {}
  }
}

export function deleteUserDailyEffort(
  studentId: number,
  effortId: number
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(deleteUserDailyEffortRequest())

    if (!isNaN(effortId)) {
      let url = `${getApiBaseUrlWithOrg(
        state.organization.orgId
      )}/mentor/course_sections/${
        state.mystudents.courseSectionId
      }/user_daily_efforts/${effortId}`

      try {
        checkHttpStatus(
          await fetch(url, {
            method: 'DELETE',
            headers: getApiHeaders(state)
          })
        )

        dispatch(deleteUserDailyEffortSuccess(studentId, effortId))
      } catch (error) {}
    } else {
      dispatch(deleteUserDailyEffortSuccess(studentId, effortId))
    }
  }
}
